import { AddCircle, Cancel, CheckCircle, Create, Search } from "@mui/icons-material"
import { Box, Button } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState, useContext, useEffect } from "react"
import ConfirmModal from "../../../Components/ConfirmModal/ConfirmModal"
import OneButton from "../../../Components/OneButton/OneButton"
import OneInput from "../../../Components/OneInput/OneInput"
import OneTable from "../../../Components/OneTable/OneTable"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { filtroTextoPesquisa, showNotify } from "../../../Utils/Utils"
import { CadastroTag } from "./CadastroTags/CadastroTags"

const ColorBox = ({ color }) => {
    return (
        <Box sx={{ backgroundColor: color, width: '20px', height: '20px', borderRadius: '5px' }} />
    )
}

const TagsConfig = () => {
    const [openCadastro, setOpenCadastro] = useState(false)
    const [idToEdit, setIdToEdit] = useState(null)

    const tableColumns = [
        {
            name: 'Código',
            selector: row => row.id,
            grow: 0.4
        },
        {
            name: 'Texto',
            selector: row => row.descricao,
            grow: 30
        },
        {
            name: 'Cor',
            selector: row => <ColorBox color={row.cor} />
        },
        {
            name: 'Ativo',
            selector: row => row.ativo ? <CheckCircle sx={{ color: "green" }} /> : <Cancel sx={{ color: "red" }}/>
        },
        {
            name: 'Editar',
            cell: (row) => <Create sx={{ cursor: 'pointer' }} onClick={() => { editTag(row.id) }}/>,
            button: true
        }
        // {
        //     name: 'Excluir',
        //     cell: (row) => <Delete sx={{ cursor: 'pointer', color: 'red' }} onClick={() => { setDeleteIdTag(row.id); setConfirmDelete(true) }}/>,
        //     ignoreRowClick: true,
        //     button: true
        // }
    ]

    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [filterText, setFilterText] = useState('')
    const [textToSearch, setTextToSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [tagList, setTagList] = useState(false)
    const filteredDataList = filtroTextoPesquisa(tagList, filterText, ['descricao'])

    const [confirmDelete, setConfirmDelete] = useState(false)
    const [deleteIdTag, setDeleteIdTag] = useState(null)

    const handleSearch = (event) => {
        event.preventDefault()
        setFilterText(textToSearch)
    }

    const handleChange = (event) => {
        setTextToSearch(event.target.value)
    }

    const getWsResponse = (msg) => {
        setTagList(msg.data.tags)
        setLoading(true)
    }

    useEffect(() => {
        addRoute("buscarTodasTags", getWsResponse)
        sendWs("buscarTodasTags")
    }, [])

    const editTag = (id) => {
        setIdToEdit(id)
        setOpenCadastro(true)
    }

    const getDeleteResponse = (msg) => {
        if (msg.data.status) {
            showNotify("success", "Tag deletada com sucesso")
            sendWs("buscarTodasTags")
            setConfirmDelete(false)
            setDeleteIdTag(null)
        } else {
            showNotify("error", msg.data.message)
            setConfirmDelete(false)
        }
    }

    const deleteTag = () => {
        addRoute("deleteTag", getDeleteResponse)
        sendWs("deleteTag", { id: deleteIdTag })
    }

    return (
        <Grid xs={12} sx={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'column' }} flexDirection="column" rowGap={1}>
            {openCadastro &&
            <CadastroTag
                openCadastro={openCadastro}
                setOpenCadastro={setOpenCadastro}
                idToEdit={idToEdit}
                setIdToEdit={setIdToEdit}
            />
            }
            {confirmDelete &&
                <ConfirmModal
                    titleText="Deletar Tag"
                    open={confirmDelete}
                    text="Você deseja deletar a tag?"
                    setOpen={setConfirmDelete}
                    cancelFunction={() => setConfirmDelete(false)}
                    confirmFunction={deleteTag}
                />
            }
            <Grid container xs={12} sx={{ alignItems: 'center', height: '50px' }}>
                <Grid xs={12} sm={6}>
                    <form
                        onSubmit={handleSearch}
                    >
                        <Grid container columnGap={1} xs={12} sx={{ alignItems: 'center' }}>
                            <Grid xs={6} sm={7.5}>
                                <OneInput name="pesquisar" onChange={handleChange} />
                            </Grid>
                            <Grid xs={4} sm={4}>
                                <OneButton
                                    id="button_teste"
                                    color="one_primary"
                                    variant="contained"
                                    type="submit"
                                    IconStart={Search}
                                >
                                     Pesquisar
                                </OneButton>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
                <Grid xs={6} sx={{ alignItems: 'center' }}>
                    <Grid container justifyContent="flex-end">
                        <Button
                            id="button_teste"
                            color="one_primary"
                            variant="contained"
                            onClick={() => { setIdToEdit(null); setOpenCadastro(true) }}
                            sx={{ width: '148px', height: '30px' }}
                        >
                            <AddCircle sx={{ marginRight: '7px' }} />
                            Novo
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container xs={12} sx={{
                // padding: '5px',
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                display: 'flex',
                flexGrow: 1,
                flexBasis: 'auto'
                // overflowY: 'scroll',
                // "::-webkit-scrollbar": {
                //     width: "6px",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-track": {
                //     background: "#D9D9D9",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb": {
                //     background: "#888",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb:hover": {
                //     background: "#555",
                //     borderRadius: '5px'
                // }
            }}>
                {tagList &&
                <OneTable
                    columns={tableColumns}
                    data={filteredDataList}
                    progressPending={!loading}
                    dobleClickCallback={editTag}
                    // pagination
                    // paginationPerPage={rowsPage}
                    // paginationRowsPerPageOptions={[rowsPage, 5, 10, 15, 20, 25, 30]}
                    // paginationComponentOptions={ { rangeSeparatorText: "de", rowsPerPageText: 'Itens por página' } }
                />
                }
            </Grid>
        </Grid>
    )
}

export default TagsConfig
